import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetAllExpeditionResponseDtoExpedition } from "@/types/api/api-types";
import { DropzoneStyled } from "@/components/styled/dropzoneStyled";
import { Modal } from "@/components/ui/customs/modal";
import { OcrModalWaitingScreen } from "./ocrModalWaitingScreen";
import { OcrModalResponseScreen } from "./ocrModalResponseScreen";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

type OcrModalProps = {
  onClose: () => void;
  prev: () => void;
  expedition: GetAllExpeditionResponseDtoExpedition;
};

export const OcrModal = ({ onClose, prev, expedition }: OcrModalProps) => {
  const { t } = useTranslation("boExpeditions");
  const [invoice, setInvoice] = useState<File[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [responseState, setResponseState] = useState<number>(0);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setLoading(true);
    if (!invoice) return;
    setTimeout(() => {
      setResponseState(1);
      setLoading(false);
    }, 1000);
  };

  useEffect(() => {
    if (invoice !== null) handleSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoice]);

  const handleRemoveFile = () => {
    setInvoice(null);
  };

  const handleFileChange = (file: any) => {
    if (file && file[0]) {
      setInvoice([...file]);
    }
  };

  const navigateToPendingShipmentsManualPage = () => {
    setTimeout(() => {
      navigate(`/update-cotation/ocr/${expedition.id}`, {
        state: {
          invoice,
        },
      });
    }, 600);
  };

  if (responseState) {
    return (
      <OcrModalResponseScreen
        navigateToPendingShipmentsManualPage={navigateToPendingShipmentsManualPage}
      />
    );
  }

  if (loading) {
    return <OcrModalWaitingScreen />;
  }

  return (
    <Modal
      open
      onClose={onClose}
      title={
        <div className="flex w-full flex-row items-center justify-between gap-4">
          <button type="button" onClick={prev}>
            <ChevronLeft />
          </button>
          <span className="text-center">{t("pendingShipmentsOcrModal.title")}</span>
          <div className="w-6" />
        </div>
      }
      size="md"
    >
      <div className="flex max-h-[70vh] flex-col gap-8 overflow-auto md:flex">
        <DropzoneStyled
          files={invoice}
          setFiles={setInvoice}
          handleFileChange={handleFileChange}
          handleRemoveFile={handleRemoveFile}
          dropZoneText={t("pendingShipmentsOcrModal.dropZoneText")}
          dropZoneSubText={t("pendingShipmentsOcrModal.dropZoneSubText")}
          accept={{
            "image/*": [".png", ".jpg", ".jpeg"],
            "application/pdf": [".pdf"],
          }}
        />
      </div>
    </Modal>
  );
};
